document.addEventListener('DOMContentLoaded', function () {
  var tabGroups = document.querySelectorAll('[data-tabbed-collections-tabs]');

  tabGroups.forEach(function (tabGroup) {
    var tabs = tabGroup.querySelectorAll('[data-tabbed-collections-tab]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var targetId = tab.getAttribute('data-target');
        var targetPanel = document.getElementById(targetId);
        if (!targetPanel) return;

        var section = tabGroup.closest('.tabbed-collections');
        if (!section) return;

        section.querySelectorAll('[data-tabbed-collections-tab]').forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        section.querySelectorAll('[data-tabbed-collections-panel]').forEach(function (p) {
          p.classList.remove('is-active');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        targetPanel.classList.add('is-active');
      });
    });
  });
});